import React from 'react';
import Button from 'react-bootstrap/Button';
import { ITodo } from '../interfaces/todo';

interface TodoItemProps {
  todo: ITodo;
  markComplete: any;
  delTodo: any;
}

export class TodoItem extends React.Component<TodoItemProps> {
  // Ternary op
  getStyle = () => {
    return {
      background: '#f4f4f4',
      padding: '10px',
      borderBottom: '1px #ccc dotted',
      textDecoration: this.props.todo.checked ? 'line-through' : 'none',
    };
  };

  render() {
    // Destructuring to get id and text so do not have to do for each of one
    const { id, text } = this.props.todo;
    return (
      <div style={this.getStyle()}>
        <p>
          <input
            type="checkbox"
            onChange={this.props.markComplete.bind(this, id)}
          />{' '}
          {text}
          <Button onClick={this.props.delTodo.bind(this, id)} style={btnStyle}>
            x
          </Button>
        </p>
      </div>
    );
  }
}

const btnStyle = {
  background: '#ff0000',
  color: '#fff',
  border: 'none',
  float: 'right',
  outline: 'none',
} as React.CSSProperties;

export default TodoItem;
